var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "600",
      "title": "权责修改申请表"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top",
      "loading": _vm.customerLoading
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-left"
  }, [_c('FormItem', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "label": "客户",
      "prop": "customer"
    }
  }, [_c('Input', {
    model: {
      value: _vm.currentCustomerQz.name,
      callback: function ($$v) {
        _vm.$set(_vm.currentCustomerQz, "name", $$v);
      },
      expression: "currentCustomerQz.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "开发 40%",
      "prop": "dev"
    }
  }, [_vm._l(_vm.devList, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "distribution-item-update"
    }, [_c('Select', {
      staticStyle: {
        "width": "120px",
        "margin-right": "16px"
      },
      attrs: {
        "placeholder": "选择人员",
        "filterable": "",
        "clearable": ""
      },
      on: {
        "on-select": function ($event) {
          return _vm.selectedUser($event, index, 'devList');
        }
      },
      model: {
        value: item.user._id,
        callback: function ($$v) {
          _vm.$set(item.user, "_id", $$v);
        },
        expression: "item.user._id"
      }
    }, _vm._l(_vm.userList, function (uu) {
      return _c('Option', {
        key: uu._id,
        attrs: {
          "value": uu._id
        }
      }, [_vm._v(_vm._s(uu.name))]);
    }), 1), _c('InputNumber', {
      attrs: {
        "placeholder": "比例",
        "max": 100,
        "min": 1
      },
      on: {
        "on-blur": _vm.devRatioRule
      },
      model: {
        value: item.ratio,
        callback: function ($$v) {
          _vm.$set(item, "ratio", $$v);
        },
        expression: "item.ratio"
      }
    }), _vm._v("% ")], 1);
  }), _c('Button', {
    attrs: {
      "type": "info",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.addRow('devList');
      }
    }
  }, [_vm._v("添加一行")])], 2), _c('FormItem', {
    attrs: {
      "label": "维护 30%",
      "prop": "maintain"
    }
  }, [_vm._l(_vm.maintainList, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "distribution-item-update"
    }, [_c('Select', {
      staticStyle: {
        "width": "120px",
        "margin-right": "16px"
      },
      attrs: {
        "placeholder": "选择人员",
        "filterable": "",
        "clearable": ""
      },
      on: {
        "on-select": function ($event) {
          return _vm.selectedUser($event, index, 'maintainList');
        }
      },
      model: {
        value: item.user._id,
        callback: function ($$v) {
          _vm.$set(item.user, "_id", $$v);
        },
        expression: "item.user._id"
      }
    }, _vm._l(_vm.userList, function (uu) {
      return _c('Option', {
        key: uu._id,
        attrs: {
          "value": uu._id
        }
      }, [_vm._v(_vm._s(uu.name))]);
    }), 1), _c('InputNumber', {
      attrs: {
        "placeholder": "比例",
        "max": 100,
        "min": 1
      },
      on: {
        "on-blur": _vm.maintainRatioRule
      },
      model: {
        value: item.ratio,
        callback: function ($$v) {
          _vm.$set(item, "ratio", $$v);
        },
        expression: "item.ratio"
      }
    }), _vm._v("% ")], 1);
  }), _c('Button', {
    attrs: {
      "type": "info",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.addRow('maintainList');
      }
    }
  }, [_vm._v("添加一行")])], 2), _c('FormItem', {
    attrs: {
      "label": "回款 30%",
      "prop": "payment"
    }
  }, [_vm._l(_vm.paymentList, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "distribution-item-update"
    }, [_c('Select', {
      staticStyle: {
        "width": "120px",
        "margin-right": "16px"
      },
      attrs: {
        "placeholder": "选择人员",
        "filterable": "",
        "clearable": ""
      },
      on: {
        "on-select": function ($event) {
          return _vm.selectedUser($event, index, 'paymentList');
        }
      },
      model: {
        value: item.user._id,
        callback: function ($$v) {
          _vm.$set(item.user, "_id", $$v);
        },
        expression: "item.user._id"
      }
    }, _vm._l(_vm.userList, function (uu) {
      return _c('Option', {
        key: uu._id,
        attrs: {
          "value": uu._id
        }
      }, [_vm._v(_vm._s(uu.name))]);
    }), 1), _c('InputNumber', {
      attrs: {
        "placeholder": "比例",
        "max": 100,
        "min": 1
      },
      on: {
        "on-blur": _vm.paymentRatioRule
      },
      model: {
        value: item.ratio,
        callback: function ($$v) {
          _vm.$set(item, "ratio", $$v);
        },
        expression: "item.ratio"
      }
    }), _vm._v("% ")], 1);
  }), _c('Button', {
    attrs: {
      "type": "info",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.addRow('paymentList');
      }
    }
  }, [_vm._v("添加一行")])], 2)], 1), _c('div', {
    staticClass: "form-right"
  }, [_c('FormItem', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "label": "区域经理",
      "prop": "regionalCharger"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "选择人员",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.regionalCharger,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "regionalCharger", $$v);
      },
      expression: "formItem.regionalCharger"
    }
  }, _vm._l(_vm.userList, function (uu) {
    return _c('Option', {
      key: uu._id,
      attrs: {
        "value": uu._id
      }
    }, [_vm._v(_vm._s(uu.name))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "label": "销售可见人",
      "prop": "salesVisibleMember"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "选择人员",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.salesVisibleMember,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "salesVisibleMember", $$v);
      },
      expression: "formItem.salesVisibleMember"
    }
  }, _vm._l(_vm.userList, function (uu) {
    return _c('Option', {
      key: uu._id,
      attrs: {
        "value": uu._id
      }
    }, [_vm._v(_vm._s(uu.name))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "label": "技术可见人",
      "prop": "techVisibleMember"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "选择人员",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.techVisibleMember,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "techVisibleMember", $$v);
      },
      expression: "formItem.techVisibleMember"
    }
  }, _vm._l(_vm.userList, function (uu) {
    return _c('Option', {
      key: uu._id,
      attrs: {
        "value": uu._id
      }
    }, [_vm._v(_vm._s(uu.name))]);
  }), 1)], 1)], 1)]), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }